import { Layout } from "@/components/layout/Layout";
import { motion } from "framer-motion";

export default function Terms() {
  return (
    <Layout>
      <section className="pt-32 pb-20 bg-background">
        <div className="container px-4 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl font-bold text-foreground mb-8">
              תנאי שימוש
            </h1>
            
            <div className="prose prose-lg max-w-none text-muted-foreground">
              <p className="lead">
                ברוכים הבאים לאתר אדם בטיחות. השימוש באתר כפוף לתנאים המפורטים להלן.
              </p>

              <h2 className="text-foreground">קבלת התנאים</h2>
              <p>
                בעצם השימוש באתר זה, הנך מאשר כי קראת, הבנת ומסכים לתנאי השימוש. 
                אם אינך מסכים לתנאים אלו, אנא הימנע משימוש באתר.
              </p>

              <h2 className="text-foreground">שימוש באתר</h2>
              <p>
                האתר מיועד לספק מידע על שירותי הבטיחות שלנו. 
                אתה מתחייב להשתמש באתר למטרות חוקיות בלבד ובהתאם לתנאים אלו.
              </p>

              <h2 className="text-foreground">קניין רוחני</h2>
              <p>
                כל התוכן באתר, כולל טקסטים, תמונות, לוגואים, גרפיקה ועיצוב, 
                הם קניינה הבלעדי של אדם בטיחות ומוגנים על פי חוקי זכויות יוצרים.
              </p>

              <h2 className="text-foreground">מידע באתר</h2>
              <p>
                אנו עושים מאמצים לספק מידע מדויק ועדכני, אך איננו מתחייבים לדיוק, שלמות או עדכניות המידע. 
                השימוש במידע הוא על אחריותך בלבד.
              </p>

              <h2 className="text-foreground">הגבלת אחריות</h2>
              <p>
                אדם בטיחות לא תישא באחריות לכל נזק ישיר, עקיף, מיוחד או תוצאתי 
                הנובע מהשימוש או חוסר היכולת להשתמש באתר.
              </p>

              <h2 className="text-foreground">קישורים לאתרים חיצוניים</h2>
              <p>
                האתר עשוי להכיל קישורים לאתרים חיצוניים. אנו לא אחראים לתוכן או למדיניות הפרטיות של אתרים אלו.
              </p>

              <h2 className="text-foreground">שינויים בתנאים</h2>
              <p>
                אנו שומרים לעצמנו את הזכות לשנות תנאים אלו בכל עת. 
                המשך השימוש באתר לאחר שינויים מהווה הסכמה לתנאים המעודכנים.
              </p>

              <h2 className="text-foreground">דין חל וסמכות שיפוט</h2>
              <p>
                תנאים אלו כפופים לחוקי מדינת ישראל. 
                כל מחלוקת תידון בבתי המשפט המוסמכים בישראל.
              </p>

              <h2 className="text-foreground">יצירת קשר</h2>
              <p>
                לשאלות בנוגע לתנאי השימוש, אנא צרו קשר בכתובת: Support@Adam-Safety.com
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                עדכון אחרון: ינואר 2024
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
